import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";

import Style from "@client/utils/Style";

import Button from "../Button";
import loadingImage from "./images/loading.svg";

const ButtonStyled = styled(Button)`
  position: relative;
`;
const Loading = styled.span`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 16px;
  height: 16px;
  background: url("${loadingImage}") center no-repeat;
  ${Style.animations.rotation}
`;

type Props = {
  children: React.ReactNode;
  large?: boolean;
  style?: React.CSSProperties;
};
@observer
class ButtonLoading extends React.Component<Props> {
  render() {
    return (
      <ButtonStyled {...this.props} disabled>
        <span>
          {this.props.children}
          <Loading />
        </span>
      </ButtonStyled>
    );
  }
}

export default ButtonLoading;
